module.exports = __webpack_public_path__ + "img/四川天府新区籍田幼儿园.4b5c7c6e.jpg";